
"t";
import React, { useState } from "react";
import { Grid, Box, Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import "../../style/components.css"; // Ensure styles are added properly


const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "90%",
        left: "70%",
        top: "0",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
        //backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
        width: "97%",
    },
}));




const TogetherSection = ({ title, subTitle }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

 

    return (
        <MainContainer>
            <ContentContainer>
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    sx={{ width: { xs: "100%", md: "80%" } }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb: 3,
                            textAlign: "center",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "14px", md: "18px" },
                            lineHeight: 1.8,
                            textAlign: "center",
                            marginTop: 2,
                            marginBottom: 10,
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>


            </ContentContainer>
        </MainContainer>
    );
};

export default TogetherSection;






